export default __webpack_public_path__ + "static/nestjs-state-of-js-2023-e73c7b33cdc12e0eb686007a28488a3d.png";